import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEmpresaAuth } from '../../contexts/EmpresaAuthContext';
import { useStaffAuth } from '../../contexts/StaffAuthContext';

// Puerta común de las pantallas de venta.
//   mode 'empresa': el dueño (siempre puede vender).
//   mode 'staff'  : solo el rol `operator` (`permissions.sell` de GET /api/auth/staff/me;
//                   el backend lo vuelve a comprobar en BD). Un `scanner` ve un aviso.
// status: 'loading' | 'redirect' | 'connection-error' | 'denied' | 'ok'
const useSalesAccess = (mode) => {
  const isStaff = mode === 'staff';
  const navigate = useNavigate();
  const { empresa } = useEmpresaAuth();
  const staffAuth = useStaffAuth();
  const { staff, loading, connectionError } = staffAuth;

  useEffect(() => {
    if (isStaff && !loading && !staff && !connectionError) {
      navigate('/staff/login', { replace: true });
    }
    if (!isStaff && !empresa) {
      navigate('/empresa/login', { replace: true });
    }
  }, [isStaff, loading, staff, connectionError, empresa, navigate]);

  let status = 'ok';
  if (isStaff) {
    if (loading) status = 'loading';
    else if (!staff) status = connectionError ? 'connection-error' : 'redirect';
    else if (!(staff.permissions ? staff.permissions.sell : staff.role === 'operator')) status = 'denied';
  } else if (!empresa) {
    status = 'redirect';
  }

  const businessName = isStaff
    ? (staffAuth.empresa && staffAuth.empresa.businessName)
    : (empresa && empresa.businessName);

  return {
    mode,
    isStaff,
    status,
    businessName: businessName || '',
    headerType: isStaff ? 'staff' : 'empresa',
    staffAuth,
  };
};

export default useSalesAccess;
